export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const GET_PROFILE_ERROR = 'GET_PROFILE_ERROR'
export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST'
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR'
export const LOAD_ADDRESS_REQUEST = 'LOAD_ADDRESS_REQUEST'
export const LOAD_ADDRESS_SUCCESS = 'LOAD_ADDRESS_SUCCESS'
export const LOAD_ADDRESS_ERROR = 'LOAD_ADDRESS_ERROR'
export const ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST'
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS'
export const ADD_ADDRESS_ERROR = 'ADD_ADDRESS_ERROR'
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS'
export const DELETE_ADDRESS_ERROR = 'DELETE_ADDRESS_ERROR'
export const EDIT_ADDRESS_REQUEST = 'EDIT_ADDRESS_REQUEST'
export const EDIT_ADDRESS_SUCCESS = 'EDIT_ADDRESS_SUCCESS'
export const EDIT_ADDRESS_ERROR = 'EDIT_ADDRESS_ERROR'
export const LOAD_CONTACTS_REQUEST = 'LOAD_CONTACTS_REQUEST'
export const LOAD_CONTACTS_SUCCESS = 'LOAD_CONTACTS_SUCCESS'
export const LOAD_CONTACTS_ERROR = 'LOAD_CONTACTS_ERROR'
export const ADD_CONTACT_REQUEST = 'ADD_CONTACTS_REQUEST'
export const ADD_CONTACT_SUCCESS = 'ADD_CONTACTS_SUCCESS'
export const ADD_CONTACT_ERROR = 'ADD_CONTACTS_ERROR'
export const CLEAR_CONTACT_ERROR = 'CLEAR_CONTACT_ERROR'
export const EDIT_CONTACT_SUCCESS = 'EDIT_CONTACT_SUCCESS'
export const EDIT_CONTACT_ERROR = 'EDIT_CONTACT_ERROR'
export const DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS'
export const DELETE_CONTACT_ERROR = 'DELETE_CONTACT_ERROR'
export const LOAD_POSTCODE_REQUEST = 'LOAD_POSTCODE_REQUEST'
export const LOAD_POSTCODE_SUCCESS = 'LOAD_POSTCODE_SUCCESS'
export const LOAD_POSTCODE_ERROR = 'LOAD_POSTCODE_ERROR'
export const CLEAR_POSTCODE_ERROR = 'CLEAR_POSTCODE_ERROR'
export const CLEAR_ADDRESS_FORM = 'CLEAR_ADDRESS_FORM'
export const GET_CARD_SUCCESS = 'GET_CARD_SUCCESS'
export const GET_CARD_ERROR = 'GET_CARD_ERROR'
export const ADD_CARD_REQUEST = 'ADD_CARD_REQUEST'
export const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS'
export const ADD_CARD_ERROR = 'ADD_CARD_ERROR'
export const CLEAR_CARD_ERROR = 'CLEAR_CARD_ERROR'
export const EDIT_CARD_REQUEST = 'EDIT_CARD_REQUEST'
export const EDIT_CARD_SUCCESS = 'EDIT_CARD_SUCCESS'
export const EDIT_CARD_ERROR = 'EDIT_CARD_ERROR'
export const DELETE_CARD_ERROR = 'DELETE_CARD_ERROR'
export const DELETE_CARD_SUCCESS = 'DELETE_CARD_SUCCESS'
export const KICKBOX_SUCCESS = 'KICKBOX_SUCCESS'
export const KICKBOX_ERROR = 'KICKBOX_ERROR'
export const CLEAR_PROFILE_ERRORS = 'CLEAR_PROFILE_ERRORS'
export const RESET_ADDRESS_ERROR = 'RESET_ADDRESS_ERROR'
export const LEAVE_BABY_CLUB_SUCCESS = 'LEAVE_BABY_CLUB_SUCCESS'
export const LEAVE_BABY_CLUB_ERROR = 'LEAVE_BABY_CLUB_ERROR'
